import { Injectable } from '@angular/core';
import { TreeviewI18n, TreeviewSelection } from '@laijuthomas/ngx-treeview';

@Injectable({
  providedIn: 'root'
})
export class TreeViewI18nCustom  extends TreeviewI18n {

  constructor(
  
  ) {
    super();
  }

  getText(selection: TreeviewSelection): string {
    if (selection.uncheckedItems.length === 0) {
      if (selection.checkedItems.length > 0) {
        return   'All';
      } else {
        return '';
      }
    }

    switch (selection.checkedItems.length) {
      case 0:
        return 'Select options' ;
      case 1:
        return selection.checkedItems[ 0 ].text;
      default:
        return `${selection.checkedItems.length} options selected`;
        
    }
  }

  getAllCheckboxText(): string {
      return 'All';
  }

  getFilterPlaceholder(): string {
      return 'Search';
  }

  getFilterNoItemsFoundText(): string {
      return 'No items found';
  }

  getTooltipCollapseExpandText(isCollapse: boolean): string {
    return isCollapse ?  'Expand' :  'Collapse' ;
  }
}
